import OptionalTestEmailView from './OptionalTestEmailView';

export default OptionalTestEmailView;
